import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../../../components/Table/GlobalFilter";
import Toast from "../../../../components/Toast";
import { COLUMNS } from "./ServiceColumns";
import '../../CenterAdmin/ManageStaff/ManageStaff.scss';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Button, Typography } from "@mui/material";
import { deleteConsultantServiceDetail, getAllMasterServicesDetails } from "core/services/api";
import { ServiceForCenter } from "./ServiceForCenter";
import { useSelector } from "react-redux";



interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}
export default function Service() {
  const history = useHistory()
  const [displayToast, toggleDisplayToast] = useState<any>()
  const columns = useMemo(() => COLUMNS, [])
  const [data, setData] = useState([])
  const componentRef = useRef()
  const userRole = useSelector((state: any) => state?.user?.role)
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly)
  const location = useLocation()


  const redirectTo = (path: any, origin: any) => {
    localStorage.removeItem("globalFilterMaster")
    localStorage.removeItem("globalFilterCenter")

    if (origin == "edit") {
      history.push({
        pathname: "/Services",
        state: { idValue: path, type: 'Master', functionType: 'edit' },
      })
    }
    if (origin == "add") {
      history.push({
        pathname: "/Services",
        state: { idValue: path, type: 'Master', functionType: 'add' },
      })
    }

  }



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  console.log(state, "state inside global filter");

  const [isServiceDeleted, setIsServiceDeleted] = useState<any>(false);
  const handleDelete = (path: any) => {
    deleteConsultantServiceDetail(`${path}`)
      .then((res) => {
        toggleDisplayToast({
          // @ts-ignore
          text: `This Service has been deleted successfully`,
          type: "success",
        })
        // setIsServiceDeleted(true);
        getAdminServices()
      })
      .catch((err) => {
        toggleDisplayToast({
          // @ts-ignore
          text: `Error in deleting this service!`,
          type: "error",
        })
        console.log("err", err)
      })
  }

  useEffect(() => {
    getAdminServices()
  }, [isServiceDeleted])


  function getAdminServices() {
    const query = `services`
    getAllMasterServicesDetails(query)
      .then((res) => {
        setData(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const element = document.getElementById("service-wrapper")
  useEffect(() => {
    console.log("inside scroll view");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }, [element, data])

  useEffect(() => {
    // Load the stored filter value from local storage
    const storedFilter = localStorage.getItem('globalFilterMaster');
    console.log(storedFilter, "stored Filter")
    if (storedFilter) {
      setGlobalFilter(storedFilter); // Apply the stored filter to the table
    }
  }, [setGlobalFilter, data]);

  const TabView = () => {
    const [value, setValue] = React.useState(0)
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue)
      localStorage.removeItem("globalFilterMaster")
      localStorage.removeItem("globalFilterCenter")
    }




    useEffect(() => {
      console.log(location?.state?.value, "location state value");
      if (location?.state?.value == undefined) {
        setValue(0);
        localStorage.removeItem("globalFilterMaster")
        localStorage.removeItem("globalFilterCenter")
      }
      else {
        setValue(location?.state?.value);
      }

    }, [])


    return (
      <Box sx={{ width: "100%", marginTop: "28px" }}>
        <Box sx={{}}>
          <Tabs
            TabIndicatorProps={{
              sx: {
                bgcolor: "blue",
                height: "2px",
                color: "blue",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Master Service List"
              {...a11yProps(1)}
            />
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Center Service List"
              {...a11yProps(0)}
            />

          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {AppointmentService()}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {ServiceForCenter()}
        </TabPanel>

      </Box>
    )
  }

  const CenterAdminView = (() => {
    return (
      <div>
        <div className="center-list-heading"
          style={{
            fontSize: '24px !important',
            fontWeight: '800',
            marginLeft: '20px',
            marginTop: '20px',
            marginBottom: '20px'
          }}
        >Center Service List</div>
        {ServiceForCenter()}
      </div>
    )
  })

  const AppointmentService = () => {


    return (
      <div className="manage-patients-container" id="service-wrapper">
        <div className="manage-patients-container">
          <div className="row add-new">
            <div className="col-9"></div>
            <div className="col-3 add-new-text">
              <Button
                className={`button-container ${readOnly ? "read-only-button" : ""}`}
                disabled={readOnly}
                onClick={() => redirectTo
                  ("", "add")}
              >
                Add New Master Service
              </Button>
            </div>
            <div className="search-container">
              <div>

                <GlobalFilter
                  filter={globalFilter}
                  setFilter={setGlobalFilter}

                />
              </div>
            </div>
            <div>
              <table
                {...getTableProps()}
                // @ts-ignore
                ref={componentRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "40px",
                            }}
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : ""}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="border-radiusImportant"
                  {...getTableBodyProps()}
                >
                  {rows.map((row) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                        {row.cells.map((cell: any) => {
                          return (
                            <td
                              onClick={() => {
                                if (readOnly) {
                                  if (cell?.column?.id?.toLowerCase() === "edit") {
                                    redirectTo(cell?.row?.original?.id, "edit")
                                  }
                                }
                                else {
                                  if (
                                    cell?.column?.id?.toLowerCase() === "delete"
                                  ) {
                                    toggleDisplayToast({
                                      // @ts-ignore
                                      text: `Are you sure you want to delete the Service?`,
                                      type: "warning",
                                      onClickText: "Yes",
                                      // @ts-ignore
                                      patient: cell?.row?.original?.id,
                                    })
                                  }
                                  if (cell?.column?.id?.toLowerCase() === "edit") {
                                    redirectTo(cell?.row?.original?.id, "edit")

                                  }
                                }
                              }}
                              style={{
                                maxWidth: "300px",
                                width: "300px",
                                wordWrap: "break-word",
                                maxHeight: "100px",
                                paddingLeft: "40px",
                                verticalAlign: "left",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "18px",
                                lineHeight: "24px",
                                letterSpacing: "1.35px",
                                textAlign: "initial",
                                textTransform: "capitalize",
                              }}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  {footerGroups.map((footerGroup) => (
                    <tr {...footerGroup.getFooterGroupProps()}>
                      {footerGroup.headers.map((column) => (
                        <td {...column.getFooterProps()}>
                          {column.render("Footer")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        {displayToast && (
          <Toast
            // @ts-ignore
            textMessage={displayToast?.text}
            // @ts-ignore
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={
              // @ts-ignore
              displayToast?.onClickText ? displayToast?.onClickText : null
            }
            onClick={() =>
              // @ts-ignore
              displayToast?.patient
                ? // @ts-ignore
                handleDelete(displayToast?.patient)
                : null
            }
            // @ts-ignore
            type={displayToast?.type}
          />
        )}
      </div>
    )
  }
  return (

    <div className="manage-staff-patients-container" id="service-wrapper">
      <div className="manage-staff-patients-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/")
          }}
        >
          <img

            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="manage-staff-text">Services</div>
      </div>
      {/* {TabView()} */}
      {userRole === "CENTER_ADMIN" ? <>{CenterAdminView()}</> : <>{TabView()}</>}

      {/* {AppointmentService()} */}

    </div>)
}









